import { unset, get } from "lodash"

/**
 * Clean programs for seo homepage to remove useless data
 *
 * Image format removed:
 * backdrop
 *   small
 *   source
 *   large
 * snapshot
 * poster
 *   source
 *   small
 *
 * Useless properties:
 * editorial
 * video
 *   asset_rights
 *
 * @param {Object} response - API response
 * @return {Object} - Cleaned response
 */
export default function cleanHomePrograms(response) {
  if (get(response, "body.sections")) {
    Object.keys(response.body.sections).forEach(section => {
      response.body.sections[section].items = (response.body.sections[section].items || []).map(program => {
        unset(program, "image_bundle.backdrop.small")
        unset(program, "image_bundle.backdrop.source")
        unset(program, "image_bundle.backdrop.large")
        unset(program, "image_bundle.snapshot")
        unset(program, "image_bundle.poster.source")
        unset(program, "image_bundle.poster.small")
        unset(program, "editorial")
        unset(program, "video.asset_rights")

        return program
      })
    })
  }

  return response
}
